import React from 'react';

const formatAddress = value => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return [value.street, value.street2, value.city, value.region, value.postal, value.country].filter(Boolean).join(', ');
};

export const AutocompleteInput = ({
  handleLocationInputChange, 
  handleInputOpen,
  handleOptionClick,
  options,
  showOptions,
  inputText,
  id = 'location-search'
}) => {
  return (
    <div className="autocompleteInput">
      <input
        id={id}
        type="text"
        value={inputText}
        onChange={handleLocationInputChange}
        onFocus={handleInputOpen}
        onClick={handleInputOpen}
        placeholder="Search by location code or address"
        autoComplete="off"
        role="combobox"
        aria-autocomplete="list"
        aria-expanded={showOptions}
        aria-controls={`${id}-options`}
      />
      {showOptions && (
        <ul id={`${id}-options`} className="autocompleteSearchOptionsWrapper">
          {options
            .filter(option => {
              const locationCode = String(option?.[35]?.value || '');
              const address = formatAddress(option?.[8]?.value);
              return locationCode.toLowerCase().includes(inputText.toLowerCase()) || address.toLowerCase().includes(inputText.toLowerCase());
            })
            .map(option => {
              const locationCode = String(option?.[35]?.value || '');
              const address = formatAddress(option?.[8]?.value);

              return (
                <li className="autocompleteSearchItem" key={String(option?.[3]?.value || locationCode)}>
                  <button type="button" onClick={() => handleOptionClick(option)}>
                    <span className="autocompleteLocationCode"><strong>{locationCode || 'Location'}</strong></span>
                    <span className="autocompleteAddress">{address}</span>
                  </button>
                </li>
              )
            })}
        </ul>
      )}
    </div>
  );
};
